import {store} from '../main';
import {AccessRights, PARTS} from "./accessRightsModel";

const hardcodedWidgetFor = ["Lowe's Canada Corporate", "FloForm Countertops Prairies", "8K Quartz"];

export const isAgentVisible = (callWidget = false) => {

  if (callWidget) {
    const {auth, asCustomer} = store.getState();
    const currentName = (asCustomer && asCustomer.activeEntity) ? asCustomer.activeEntity.companyName : auth.customerName;
    return hardcodedWidgetFor.includes(currentName)
  }

  const AR = AccessRights.get(store);
  if (AR.v(PARTS.HUB_BUTTON_AGENT) || AR.isSiteAdmin(true)) {
    return true
  }

  const {auth, asCustomer} = store.getState();
  // console.log("auth", auth);
  // console.log("asCustomer", asCustomer);
  const currentEmail = (asCustomer && asCustomer.activeEntity) ? asCustomer.activeEntity.email : auth.userEmail;
  // console.log("currentEmail", currentEmail);
  return currentEmail === "John.Laniel@rona.ca" || currentEmail === "Mourad.Dekkaki@rona.ca"
}
